import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { FiltersState } from './filters.state';
import { ClearFilter, GetFilter } from './filters.actions';
import { Filter } from '../services/models/filter.model';
import { FilterRequestParams } from '../services/models/filter-request.model';

@Injectable({
  providedIn: 'root',
})
export class FiltersFacade {
  private readonly store = inject(Store);

  @Select(FiltersState.isLoading) isLoading$: Observable<boolean>;
  @Select(FiltersState.isLoadingSearch) isLoadingSearch$: Observable<boolean>;
  @Select(FiltersState.filter) filter$: Observable<{ name: string, label: string }>;
  @Select(FiltersState.filterValues) filterValues$: Observable<Filter[]>;
  @Select(FiltersState.pagination) pagination$: Observable<{ page: number, size: number, total: number }>;

  getFilter(name: string, params: Partial<FilterRequestParams> = {}) {
    const defaultParams: FilterRequestParams = {
      facetSearch: '',
      limit: 36,
      offset: 0,
    };

    this.store.dispatch(new GetFilter(name, {
      ...defaultParams,
      ...params,
    }));
  }

  clearFilter() {
    this.store.dispatch(new ClearFilter());
  }
}
